export const RECEIVE_UPDATE_LAYOUT = "receive_update_laout";
export const REQUEST_UPDATE_LAYOUT = "request_update_laout";
export const UPDATE_LAYOUT_ERROR = "update_laout_error";
import { updateLayout } from "src/actions/modelActions";

export const REQUEST_ADD_LAYOUT = "request_add_layout";
export const RECEIVE_ADD_LAYOUT = "receive_add_layout";
export const ADD_LAYOUT_ERROR = "add_layout_error";

export const REQUEST_DELETE_LAYOUT = "request_delete_layout";
export const RECEIVE_DELETE_LAYOUT = "receive_delete_layout";
export const DELETE_LAYOUT_ERROR = "delete_layout_error";

import { addLayout, deleteLayout } from "src/actions/viewActions";

const updateLayoutRedux = layout => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_UPDATE_LAYOUT,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_UPDATE_LAYOUT,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: UPDATE_LAYOUT_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call

			const data = await updateLayout(layout);
			return onSuccess(data);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

const addLayoutRedux = (modelId, viewId, title, viewType, layoutType, layoutData) => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_ADD_LAYOUT,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_ADD_LAYOUT,
				payload: success,
				viewId: viewId,
				layoutType,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: ADD_LAYOUT_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call

			const layout = await addLayout(modelId, viewId, title, viewType, layoutType, layoutData);

			return onSuccess(layout);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};
const deleteLayoutRedux = (viewId, layoutId, layoutType) => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_DELETE_LAYOUT,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_DELETE_LAYOUT,
				payload: success,
				viewId: viewId,
				layoutType: layoutType,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: DELETE_LAYOUT_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const layout = await deleteLayout(layoutId, layoutType);

			return onSuccess(layout);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

export { updateLayoutRedux, addLayoutRedux, deleteLayoutRedux };
